import { FC, useState } from "react"

import { StatisticsObjectType } from "./types";
import Modal from "../modal";


const CustomButtonTop: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");


  const openModal = (title: string) => {
    setTitle(title);
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  return (
    <div className="row gx-2 cases-cards">
      {showingModal ? <Modal title={title} data={title === "New Practices" ? StatisticsObjectType.new_practices.data : StatisticsObjectType.new_doctors.data} onClick={() => setModal(false)} /> : null}
        <div className="col d-flex mb-3">
            <div className="card d-flex flex-row overflow-hidden flex-fill">
                <div className="card-header bg-success-subtle col-6 d-flex justify-content-center align-items-center border-0 rounded-0">
                    <h1 className="m-0 text-center" style={{color:'#008853', fontSize:'1.875rem'}}>Received Cases</h1>
                </div>
                <div className="card-body col-6 d-flex justify-content-center align-items-center">
                    <h1 className="m-0">{StatisticsObjectType.received_cases}</h1>
                </div>
            </div>
        </div>

        <div className="col d-flex mb-3">
            <div className="card d-flex flex-row overflow-hidden flex-fill">
                <div className="card-header bg-success-subtle col-6 d-flex justify-content-center align-items-center border-0 rounded-0">
                    <h1 className="m-0 text-center" style={{color:'#008853', fontSize:'1.875rem'}}>New Practices</h1>
                </div>
                <div className="card-body col-6 d-flex justify-content-center align-items-center">
                    <a href="." className="btn-link m-0 fw-bold h1" onClick={(e) => {
                        e.preventDefault();
                        openModal("New Practices")
                    }}>
                        {StatisticsObjectType.new_practices.count}
                    </a>
                </div>
            </div>
        </div>

        <div className="col d-flex mb-3">
            <div className="card d-flex flex-row overflow-hidden flex-fill">
                <div className="card-header bg-success-subtle col-6 d-flex justify-content-center align-items-center border-0 rounded-0">
                    <h1 className="m-0 text-center" style={{color:'#008853', fontSize:'1.875rem'}}>New Doctors</h1>
                </div>
                <div className="card-body col-6 d-flex justify-content-center align-items-center">
                    <a href="." className="btn-link m-0 fw-bold h1" onClick={(e) => {
                        e.preventDefault();
                        openModal("New Doctors")
                    }}>
                        {StatisticsObjectType.new_doctors.count}
                    </a>
                </div>
            </div>
        </div>

        <div className="col d-flex mb-3">
            <div className="card d-flex flex-row overflow-hidden flex-fill">
                <div className="card-header bg-success-subtle col-6 d-flex justify-content-center align-items-center border-0 rounded-0">
                    <h1 className="m-0 text-center" style={{color:'#008853', fontSize:'1.875rem'}}>Transfers</h1>
                </div>
                <div className="card-body col-6 d-flex justify-content-center align-items-center">
                    <h1 className="m-0">
                        {StatisticsObjectType.transfers === null ? `0 %` : Number(StatisticsObjectType.transfers).toFixed(2) + `%`}
                    </h1>
                </div>
            </div>
        </div>
    </div>
  )
}
export default CustomButtonTop;
